import useCases from '@/hooks/useCases';
import { getLocationOptions } from '@/utils/locationCache';
import { Box, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { grey, blue } from '@mui/material/colors';
import { observer } from 'mobx-react';
import { useState } from 'react';

export const CaseDataBarLocationItem = observer(() => {
  const cases = useCases();
  const [isUpdating, setIsUpdating] = useState(false);
  const locationOptions = getLocationOptions();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newLocation = event.target.value;

    setIsUpdating(true);
    cases
      .updateCaseLocation(newLocation)
      .catch((error) => {
        console.error('Failed to update location:', error);
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  const currentValue = cases.location || '';
  
  // If no options are available yet, don't show the dropdown
  if (locationOptions.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        borderRadius: '4px',
        padding: '8px',
        color: grey[500],
      }}
    >
      <Box
        sx={{
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '14px',
          letterSpacing: '0.15px',
        }}
        className="dd-privacy-allow"
      >
        Lokation
      </Box>
      <Select
        value={currentValue}
        onChange={handleChange}
        disabled={isUpdating}
        displayEmpty
        size="small"
        sx={{
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 400,
          letterSpacing: '0.15px',
          minWidth: '150px',
          '& .MuiSelect-select': {
            padding: '0',
            paddingRight: '24px !important',
            color: currentValue ? 'black' : grey[500],
            display: 'flex',
            alignItems: 'center',
            minHeight: '24px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${grey[300]}`,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${blue[500]}`,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
            },
          },
        }}
      >
        {!currentValue && (
          <MenuItem value="" disabled sx={{ color: grey[500] }}>
            Vælg lokation
          </MenuItem>
        )}
        {locationOptions.map((location) => (
          <MenuItem key={location} value={location}>
            {location}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
});
